import { ProseBlock, SectionHead } from "./shared";

// =========================================================================
// MEDICYS COMMENTS & ASSUMPTIONS
// =========================================================================
export function AssumptionsTab({ d, narrativeLoading }) {
  const hasContent =
    d.narrative_assumptions?.length > 0 || d.assumptions_text?.trim();
  return (
    <div className="space-y-10" data-testid="assumptions-tab">
      <SectionHead n="02" title="Medicys Comments & Assumptions" />
      {hasContent ? (
        <ProseBlock
          paragraphs={d.narrative_assumptions}
          fallback={d.assumptions_text}
        />
      ) : (
        <p
          className="text-sm text-stone-400 animate-pulse"
          data-testid="narrative-loading-assumptions"
        >
          {narrativeLoading ? "Loading assumptions…" : "No comments or assumptions provided."}
        </p>
      )}
    </div>
  );
}
